import React, { useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "../components";

const OnboardingReturn = () => {
  const { setNavigateToDashboard, checkAuth } = useStateContext();

  const navigate = useNavigate();

  useEffect(() => {
    setNavigateToDashboard(false);
    checkAuth();
    setTimeout(() => {
      navigate("/dashboard");
    }, 1000);
    clearTimeout();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <LoadingSpinner isLoading={true} />
    </div>
  );
};

export default OnboardingReturn;
